import React, { useCallback } from "react";
import MainSidebar from "./MainSidebar";
import {
  StyledAppSidebarScrollbar,
  StyledAppSidebarScrollbarContent,
} from "./index.styled";
import AppVerticalNav from "../AppVerticalNav";
import { Flex, Input } from "antd";
import { IoIosSearch } from "react-icons/io";
import AppSidebarFooter from "./AppSidebarFooter";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { HOME_ROUTE } from "_constants";
import AppLogo from "_lib/AppLogo";

const AppSideBar = (props) => {
  const { routesConfig = [] } = props;
  const navigate = useNavigate();

  const onClickLogo = useCallback(() => {
    navigate(HOME_ROUTE);
  }, [navigate]);

  return (
    <MainSidebar>
      <StyledAppSidebarScrollbarContent vertical justify="space-between">
        <Flex vertical gap={16}>
          <AppLogo height={26} width={135} onClick={onClickLogo} />
          <Input prefix={<IoIosSearch />} placeholder="Search" />
          <StyledAppSidebarScrollbar>
            <AppVerticalNav routesConfig={routesConfig} />
          </StyledAppSidebarScrollbar>
        </Flex>

        <AppSidebarFooter />
      </StyledAppSidebarScrollbarContent>
    </MainSidebar>
  );
};

AppSideBar.propTypes = {
  routesConfig: PropTypes.array,
};

export default AppSideBar;
